import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A patent for swinging on a swing",
  "description": "",
  "published": "2012-06-12T00:00:00.000Z",
  "redirect_from": ["/blog/a-patent-for-swinging-on-a-swing/swizec/4605"],
  "categories": "Claim (patent), Invention, Patent, Swing, swings, Tarzan, Uncategorized, United States Patent and Trademark Office",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The patent system has gone bonkers the past few years. For proof, look no further than this wonderful gem:`}</p>
    <blockquote>
      <p parentName="blockquote">{`A method of swing on a swing is disclosed, in which a user positioned on a standard swing suspended by two chains from a substantially horizontal tree branch induces side to side motion by pulling alternatively on one chain and then the other.`}</p>
    </blockquote>
    <p>{`On April 9th, 2002 the US patent office issued a patent for `}{`_`}<a parentName="p" {...{
        "href": "http://www.google.com/patents/US6368227"
      }}>{`A Method of Swinging on a Swing`}</a>{`. `}{`_`}{`On July 1st, 2003 it was reexamined and all claims cancelled, but for a whopping 13 months this was a valid issued patent and, in theory, you could get sued for swinging in a particular way without asking permission.`}</p>
    <p>{`Yep.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-11-at-12.04.45-AM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-11-at-12.04.45-AM.png",
          "alt": "The patented swinging",
          "title": "The patented swinging"
        }}></img></a></p>
    <p>{`After describing a short history of swinging (did you know swings were patented in 1881?) - the back-and-forth and the ever so popular screw-and-spin methods - the patent claims that:`}</p>
    <blockquote>
      <p parentName="blockquote">{`These methods of swinging on a swing although of considerable interest to some people can lose their appeal with age and experience. `}<strong parentName="p">{`A new method of swinging on a swing would therefore represent an advance of great significance and value.`}</strong></p>
    </blockquote>
    <p>{`To swing like `}<em parentName="p">{`Figure 2`}</em>{` shows - side-to-side instead of front-to-back - one must merely pull on each chains alternatively. Similar to how you shift your body weight for normal swinging. A bit of imagination can make the new swinging method even more fun:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Lastly, it should be noted that because pulling alternately on one chain and then the other resembles in some measure the movements one would use to swing from vines in a dense jungle forest, the swinging method of the present invention may be referred to by `}<em parentName="p">{`the present inventor and his sister`}</em>{` as `}<strong parentName="p">{`"Tarzan" swinging. `}</strong>{`The user may even choose to produce a Tarzan-type yell while swinging in the manner described, which more accurately replicates swinging on vines in a dense jungle forest. Actual jungle forestry is not required.`}</p>
    </blockquote>
    <p>{`My swing can be a jungle vine and I can pretend to be Tarzan! No jungle forestry required! Scoar!`}</p>
    <p>{`However, it is possible to make the whole thing even more fun by incorporating back-to-front swinging to produce an oval motion - you should be careful that the side-to-side axis is longer though, otherwise it isn't as fun. Apparently.`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-11-at-12.24.32-AM.png"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/06/Screen-Shot-2012-06-11-at-12.24.32-AM.png",
          "alt": "Oval swinging",
          "title": "Oval swinging"
        }}></img></a></p>
    <p>{`Lucky for us the magnificent inventor says that`}</p>
    <blockquote>
      <p parentName="blockquote">{`Licenses are available from the inventor upon request.`}</p>
    </blockquote>
    <p>{`Which is great because my first thought after sitting on a piece of wood suspended from a bar has always been asking someone's permission to swing.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.apartmenttherapy.com/hooks-florescent-swing-by-chevalier-masson-172471"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/93673837_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.apartmenttherapy.com/hooks-florescent-swing-by-chevalier-masson-172471"
        }}>{`Hooks Swing By Chevalier Masson`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://tourreport.pgatour.com/2012/06/09/does-rory-have-the-best-swing-in-golf/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/93391430_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://tourreport.pgatour.com/2012/06/09/does-rory-have-the-best-swing-in-golf/"
        }}>{`Does Rory have the best swing in golf?`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://intellogist.wordpress.com/2012/04/02/five-fantastic-patent-pranks/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/88320274_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://intellogist.wordpress.com/2012/04/02/five-fantastic-patent-pranks/"
        }}>{`Five Fantastic Patent Pranks!`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.answers.com/topic/corpus-answers-guides-how-to-hang-a-tree-swing"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_01_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.answers.com/topic/corpus-answers-guides-how-to-hang-a-tree-swing"
        }}>{`How to Hang a Tree Swing`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.washingtonmonthly.com/ten-miles-square/2012/06/last_week_the_patent_and037875.php"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_09_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.washingtonmonthly.com/ten-miles-square/2012/06/last_week_the_patent_and037875.php"
        }}>{`Apple's Newest Patent: Wholly Unnecessary`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=1d03d140-7ac2-465f-8fe7-89871ffa4b9a",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      